import { httpCreate } from './http';

const http = httpCreate('/srv/helpdocument');

export const helpdocument = {
	pushHelpDoc(data) {
		return http.put('', data);
	},
	getHelpDoc(params) {
		return http.get('/getPage', { params });
	},
	deleteHelpDoc(data) {
		return http.post('/delete', data);
	},
	getOneHelpDoc(id) {
		return http.get('/' + id);
	},
	editHelpDoc(data) {
		return http.post('', data);
	}
};
